module.exports = __webpack_public_path__ + "media/images/locations/circle/japan-638a67bfdc885cca029603e6bc1da3c0.jpg";